import {FilesI18n} from '@/locales/base.message.locales';

export const files: FilesI18n = {
  search: 'Buscar',
  title: 'Arquivo',
  description: 'Descrição',
  buttons: {
    download: 'Baixar',
  },
};
